<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1400 -906) translate(1176 140) translate(0 614) translate(0 152) translate(224)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <g
          fill="#000"
          fill-rule="nonzero"
        >
          <g>
            <path
              d="M5.748 1.655c.344-.429.576-1.005.515-1.594-.502.025-1.115.331-1.47.761-.319.368-.6.968-.527 1.532.564.05 1.127-.281 1.482-.699M6.257 2.465c-.82-.05-1.515.464-1.906.464-.392 0-.99-.44-1.638-.428-.843.012-1.625.489-2.053 1.247-.88 1.516-.232 3.766.623 5 .416.612.917 1.285 1.576 1.26.624-.024.868-.403 1.626-.403.757 0 .977.403 1.637.391.685-.012 1.112-.611 1.528-1.223.477-.696.672-1.369.684-1.406-.012-.012-1.32-.513-1.332-2.017C6.99 4.09 8.03 3.492 8.077 3.454c-.586-.867-1.503-.965-1.82-.99"
              transform="translate(9 10)"
            />
          </g>
          <g>
            <path
              d="M3.661.027c1.78 0 3.02 1.227 3.02 3.013 0 1.792-1.265 3.025-3.064 3.025h-1.97V9.2H.222V.027H3.66zM1.646 4.87H3.28c1.24 0 1.945-.667 1.945-1.824s-.706-1.818-1.939-1.818h-1.64V4.87zM7.034 7.298c0-1.176.896-1.85 2.548-1.95l1.774-.109v-.508c0-.744-.49-1.15-1.36-1.15-.719 0-1.24.368-1.348.933H7.364c.038-1.188 1.157-2.053 2.67-2.053 1.627 0 2.688.852 2.688 2.174V9.2h-1.315v-1.1h-.032c-.375.719-1.202 1.17-2.098 1.17-1.322 0-2.243-.788-2.243-1.97zm4.322-.59v-.516l-1.583.102c-.89.057-1.354.388-1.354.966 0 .56.483.922 1.24.922.966 0 1.697-.617 1.697-1.475zM13.932 11.652v-1.1c.089.013.305.026.42.026.629 0 .985-.267 1.2-.953l.128-.407-2.41-6.674h1.488l1.678 5.415h.032l1.678-5.415h1.45l-2.499 7.01c-.572 1.609-1.227 2.137-2.612 2.137-.108 0-.458-.013-.553-.039z"
              transform="translate(9 10) translate(10.76 .734)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
